export const EVENTS_FETCH = 'EVENTS/FETCH';
export const EVENTS_FETCH_SUCCESS = 'USER/FETCH_SUCCESS';
export const EVENTS_FETCH_FAILURE = 'USER/FETCH_FAILURE';

const initialState = {};

export const fetchEvents = id => ({
  type: EVENTS_FETCH,
  payload: { id },
});

export const eventsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case EVENTS_FETCH_SUCCESS: {
      return { ...payload };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/events.reducer.js